import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PHONE_DISPLAY = "+230 5920 0029";
export const PHONE_TEL = "+23059200029";
export const WHATSAPP_NUMBER = "23059200029";

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const waLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const pick = (obj, field, lang) => obj?.[`${field}_${lang}`] ?? obj?.[`${field}_en`] ?? "";